webpackJsonp([51],{

/***/ "Om7N":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var underscore_extensions_1 = __webpack_require__("R0iF");
var SignUpBlock = (function () {
    SignUpBlock.$inject = ["$state", "AuthenticationSvc"];
    function SignUpBlock($state, AuthenticationSvc) {
        this.$state = $state;
        this.AuthenticationSvc = AuthenticationSvc;
        var defautlTitle = options.handHeld ? 'sign-up-block.mobile.title' : 'sign-up-block.title';
        this.sbTitle = this.sbTitle || defautlTitle;
    }
    SignUpBlock.prototype.isEmailInvalid = function (form) {
        return form && form.$invalid && (form.$submitted || form.$dirty);
    };
    SignUpBlock.prototype.openLoginModal = function () {
        this.AuthenticationSvc.toggleLoginModal();
    };
    SignUpBlock.prototype.openSignUp = function () {
        var state = underscore_extensions_1.Utils.getProduct().toLowerCase();
        this.$state.go(state + "-signup", { email: this.email, sendRequest: true });
    };
    return SignUpBlock;
}());
angular.module('animatronApp.signUpBlock', []).component('signUpBlock', {
    bindings: {
        isBg: '<',
        sbTitle: '<'
    },
    controller: SignUpBlock,
    templateUrl: __webpack_require__("m5k6")
});


/***/ }),

/***/ "m5k6":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "html/sign-up-block_46f49d2dace1fcb5479aaeaf9365ec37.html";

/***/ })

});


// WEBPACK FOOTER //
// javascripts/51-257c10c0995a4d25fa59.min.js